import { supabase, supabaseConfigured } from "./supabase";
import { FALLBACK_VEHICLES, FALLBACK_POSTS } from "./content";

// Tablolar henüz kurulmadıysa (veya yapılandırma eksikse) siteyi gerçek içerikle
// çalışır tutmak için fallback kullanılır. Supabase kurulumu tamamlanınca
// veriler otomatik olarak veritabanından gelir.

export async function getVehicles() {
  if (!supabaseConfigured) return FALLBACK_VEHICLES;
  try {
    const { data, error } = await supabase
      .from("vehicles")
      .select("*")
      .order("sort_order", { ascending: true });
    if (error || !data || data.length === 0) return FALLBACK_VEHICLES;
    return data;
  } catch {
    return FALLBACK_VEHICLES;
  }
}

export async function getVehicleBySlug(slug) {
  if (!supabaseConfigured)
    return FALLBACK_VEHICLES.find((v) => v.slug === slug) || null;
  try {
    const { data, error } = await supabase
      .from("vehicles")
      .select("*")
      .eq("slug", slug)
      .maybeSingle();
    if (error || !data)
      return FALLBACK_VEHICLES.find((v) => v.slug === slug) || null;
    return data;
  } catch {
    return FALLBACK_VEHICLES.find((v) => v.slug === slug) || null;
  }
}

export async function getPosts() {
  if (!supabaseConfigured) return FALLBACK_POSTS;
  try {
    const { data, error } = await supabase
      .from("blog_posts")
      .select("*")
      .eq("published", true)
      .order("created_at", { ascending: false });
    if (error || !data || data.length === 0) return FALLBACK_POSTS;
    return data;
  } catch {
    return FALLBACK_POSTS;
  }
}

export async function getPostBySlug(slug) {
  if (!supabaseConfigured)
    return FALLBACK_POSTS.find((p) => p.slug === slug) || null;
  try {
    const { data, error } = await supabase
      .from("blog_posts")
      .select("*")
      .eq("slug", slug)
      .eq("published", true)
      .maybeSingle();
    if (error || !data)
      return FALLBACK_POSTS.find((p) => p.slug === slug) || null;
    return data;
  } catch {
    return FALLBACK_POSTS.find((p) => p.slug === slug) || null;
  }
}

// Herkese açık teklif formu — RLS politikası yalnızca INSERT'e izin verir.
export async function submitQuote(payload) {
  if (!supabaseConfigured) {
    return { ok: false, error: "Supabase yapılandırması eksik." };
  }
  const { error } = await supabase.from("quote_requests").insert(payload);
  if (error) return { ok: false, error: error.message };
  return { ok: true };
}
